"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var image_1 = __importDefault(require("next/image"));
var react_select_1 = require("react-select");
var DropdownIndicator = function (props) {
    return (react_1.default.createElement(react_select_1.components.DropdownIndicator, __assign({}, props),
        react_1.default.createElement(image_1.default, { src: "/img/icons/dropdownArrow.svg", width: 15, height: 10, alt: "arrow" })));
};
exports.default = DropdownIndicator;
